import React from 'react';

/**
 * Types for BlockNode to validate invite name block in layout
 */
export type BlockNode = {
  primitive?: string;
  properties?: {
    featureKey?: string;
    propertyKey?: string;
    children?: BlockNode[];
  };
  children?: BlockNode[];
};

export type InviteNameFieldProps = {
  editMode?: boolean;
  className?: string;
  style?: React.CSSProperties;
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  validation?: object;
  isPristine?: boolean;
  isRequired?: boolean;
  isDisabled?: boolean;
  testId?: string;
};

export const REQUIRED_INDICATOR = '*';
